var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "appointment-card",
    class: {
      selected: _vm.isSelected
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "appointment-header"
  }, [_c('div', {
    staticClass: "appointment-header-content"
  }, [_c('div', {
    staticClass: "clinic-name"
  }, [_vm._v(_vm._s(_vm.reservation.summary.clinicName))]), _c('div', {
    staticClass: "patient-name"
  }, [_vm._v(_vm._s(_vm.reservation.summary.patientName || '-'))]), _c('div', {
    staticClass: "appointment-summary"
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "2",
      "x2": "16",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "2",
      "x2": "8",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "10",
      "x2": "21",
      "y2": "10"
    }
  })]), _c('span', {
    staticClass: "summary-value"
  }, [_vm._v(_vm._s(_vm.formattedDate) + " " + _vm._s(_vm.reservation.summary.slotText))])]), _c('span', {
    staticClass: "appointment-type"
  }, [_vm._v(_vm._s(_vm.reservation.summary.typeName))])])]), _c('button', {
    staticClass: "expand-btn",
    class: {
      expanded: _vm.isExpanded
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })])])]), _c('div', {
    staticClass: "appointment-details",
    class: {
      show: _vm.isExpanded
    }
  }, [_c('div', {
    staticClass: "appointment-info"
  }, _vm._l(_vm.detailFields, function (item, idx) {
    return _c('div', {
      key: "".concat(item.label, "-").concat(idx),
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(item.label))]), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.label === '費用' && item.value !== '-' ? "".concat(item.value, " \u5143") : item.value))])]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }